import { useState } from 'react';
import { CustomerApi } from '@recargas-dominicanas/core/adminApi';
import { TextField } from '@recargas-dominicanas/core/components';
import type { IProduct, Nullable } from '@recargas-dominicanas/core/types';
import type { CustomerProduct } from '@recargas-dominicanas/core/types/customerProduct.type';
import { ProductSelect } from '../../../../components/product-select/product-select.component';
import { Modal } from '../../../../components/modal/modal.component';
import { BusinessStore } from '../../../../store/businessStore';
import { useForm } from '@recargas-dominicanas/core/hooks';
import { style } from './edit-product-modal.module.css';

interface Props {
  open: boolean;
  customerId: number;
  businessId: number;
  customerProduct: CustomerProduct;
  onClose: () => void;
}

export function EditProductModal(props: Props) {

  const {
    open,
    customerId,
    businessId,
    customerProduct,
    onClose
  } = props;

  const [error, setError] = useState<string>();
  
  const form = useForm({
    product: { value: customerProduct.product as Nullable<IProduct> },
    profit: customerProduct.profit.toString()
  }, [open]);

  async function handleSave() {

    if (!form.validate()) return;

    setError(undefined);

    try {

      await CustomerApi.updateProduct(customerId, customerProduct.id, {
        profit: parseFloat(form.profit.value),
        productId: form.product.value!.id
      });

      await BusinessStore.fetchCustomerProducts(businessId, customerId);

      handleClose();

    } catch {

      setError('Error actualizando producto');
    }
  }

  function handleClose() {
    form.clear();
    setError(undefined);
    onClose();
  }

  return (
    <Modal
      open={open}
      title='Editar producto'
      style={style.modal}
      secondaryButton='Guardar'
      error={error}
      onClose={handleClose}
      onSecondaryClick={handleSave}>
      <ProductSelect
        className={style.select}
        label='Producto'
        placeholder='Seleccionar producto'
        value={form.product.value}
        error={form.product.error}
        onChange={form.product.onChange}/>
      <TextField 
        style={style.textField}
        label='Beneficio'
        type='number'
        value={form.profit.value}
        error={form.profit.error}
        onChange={form.profit.onChange}
        onBlur={form.profit.onBlur}/>
    </Modal>
  );
}
